import Route from '../services/route'
import Pagination, {Page} from './pagination';

export default {
  props: ['routeIdSelected'],
  data(){
    return {
      routes: undefined,
      page: new Page().size(5),
      loading: undefined,
      search: '',
      filterActive: true,
      isActiveArray: [],
      routeSelected: this.routeIdSelected ? this.routeIdSelected.routeId : undefined,
      showAlert: true,
      warning: false,
      msgStrong: 'Nova forma de consulta.',
      msgAlert: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.'
    }
  },
  mounted(){
  //   $('[data-toggle="tooltip"]').tooltip();
  //   this.loading = this.$store.dispatch('getRoutes').then(resp => {
  //     this.routes = this.allRoutes;
  //     
  //     this.page = this.page.itemCount(this.allRoutes.length);
  //   });
    if(this.allRoutes) {
      this.routes = this.allRoutes;
      this.page = this.page.itemCount(this.allRoutes.length);
    }
  },

  watch:{
    search() {
      this.page = this.page.page(1);
    },
    filterActive(){
      this.filter();
      this.search = '';
      this.page = this.page.page(1);
    },
    routeSelected(newVal){
      let vm = this;
      let r = _.find(this.routes, function(o){
        return o.routeId == vm.routeSelected;
      });

      vm.$emit('input', r);
    },
  },

  computed: {
    allRoutes(){
      
      if(this.filterActive)
        return this.$store.getters.getRoutesActive;

      return this.$store.state.route.inactives;
    },
    routesPaged() {
      if (this.routes && this.page) {
        for(let i=0; i<this.routes.length; i++) {
          this.$set(this.routes[i], 'open', false);
        }
        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown())
      }
      return undefined;
    }

  },
  methods: {
    searchRoutes() {
      $('[data-toggle="tooltip"]').tooltip();
        this.loading = this.$store.dispatch('getRoutes', this.search).then(resp => {
          if(this.allRoutes.length !== 0) {
            this.routes = this.allRoutes;
            this.page = this.page.itemCount(this.allRoutes.length);
            this.showAlert = false;
          } else {
            this.msgStrong = 'Rota não encontrada!';
            this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
            this.warning = true;
            this.showAlert = true;
          }
        });
    },
    // changeActive: function(r) {
    //   let vm = this;
    //   // this.isActive = !this.isActive;
    //   this.isActiveArray.length = 0;
    //   this.isActiveArray.push(r);
    //   this.routeSelected = r;
    //   
    //   vm.$emit('input', r);
    // },
    // isActive: function(id) {
    //   return this.isActiveArray.includes(id);
    // },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      // this.find();
    },

    getCity(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.city + ', ' + p.state;

      return "";
    },

    getAddress(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.address;

      return "";
    },

    imageMap(r){
      let origin = this.getAddress(r, 'origin');
      let dest = this.getAddress(r, 'destination');
      let url = "https://maps.googleapis.com/maps/api/staticmap?scale=1&size=260x150&maptype=roadmap&format=png&visual_refresh=true";
      url += `&markers=icon:https://movemais.com/static/pins/pin-origin-small.png%7Cshadow:true%7C${origin}`;
      url += `&markers=icon:https://movemais.com/static/pins/pin-destination-small.png%7Cshadow:true%7C${dest}`;

      _.filter(r.pointList.pointLocation, function(o){
        return o.type == 'waypoint';
      }).forEach(function(o){
        url += `&markers=icon:https://movemais.com/static/pins/pin-waypoint-small.png%7Cshadow:true%7C${o.address}`;
      });

      _.forEach(r.tollFeeList.tollFee, function(o){
        url += `&markers=icon:https://movemais.com/static/pins/pin-toll-small.png%7Cshadow:true%7C${o.lat},${o.lng}`;
      });

      //let polyline = encodeURI('|x}cC|{`eHfDpQtJjJrj@}N~f@oKv[yGvDyDlDj@fBj@`BI|W~CnXtCjK~HrR{_@nyFk~IjzAocCpDeZtOyRpdCkoD`bDw`FjlBkvCnrBycDnfDylObOsGvAZle@rIv]s@hBxDtKKnJIpAcBsG{AwJF_EEgMHc^Nw@oRGWsZeWnC_TdWa_@zjAu}Af]iPne@fBx`CdWlXUxtCi~A|tC}_Bn{HohEt_KalDzlA_a@nUaWj{C_uIlVeRpTkEncAhC|]j@jTaPzIcQ~KeJdHsQzBmHkCaRfCmXfHkJvw@sf@ze@gKhn@_^rj@eLvMmJzG}Rlq@{c@rUFlReE~t@g[`f@p@r^qFpb@yYt_@yq@~Xoe@vx@y}@vd@_h@js@yw@lmAalAbz@gr@x`Aqo@`wAyg@`Kl@vWHrtBzYvbAbY~`AaDjnArIxdBzPjkAhD~zBwJvh@yBprC|_@rkIfrAlzB`^`{Alt@ra@r\\p]fg@rj@to@lLrHrw@fe@js@~`A~EnFbD|DjAvC|SjSnVaNlFcF~FOh[jJlGgRbGmQs@wFxEuKjBe@nK_GtGmQq@qIoFgC}`@wRoAuGjCwJnI_DlAkJr_@kwAte@evJtBs[vPes@dx@mlB`]}y@pYqtAvcAofFf]qdBpOeN~p@wOrTmWxc@m~@rhBeuDt}@miA|w@}{@rc@}w@xt@{~Azg@chAtgAcdCla@_~CrRc~@ns@}_ArHeYvAi{@hF_f@zp@kfAnMgdA|HuO|b@qNh\\kPxRqaAfQuo@z|@s|AzEcWuHu`CdKwb@|l@guAjF}ZqAal@jE{ObZyUvwA_WhqBaE|cAkr@|r@w\\p}@{CrSsC`RuS`|A}_Blx@}eAtb@{[vnAaf@jZkb@hfAazAzj@{l@h`AieAdlBofAtl@cQny@cl@lj@yd@|`@gt@`oAquArn@gQnUyUb[kq@lq@cx@d`AkcA~b@sc@b`@kTrnBif@dqA}[d`@gUjt@kaAhqBusCxo@mo@fh@gn@xMeNb]gL~OcKzg@kv@`x@it@`cAaId[mYlL}Gb`@mCdVyL~`@me@zQ_k@~EsD~K_DfbBmBxXgDhVwLpa@eb@tS_WlN}dArXuj@jJk_@dTqPha@eLdn@_\\pe@}j@bViGncDiK|eA{a@hbA}G|aAqXlgA}MvoA_V|j@{WnT{f@tOoIl[qC|c@kMrk@ud@z`Aiu@~B_cA{CyuAdKacAlRs`@`Vu{CxKw|B~EqTnRYroBtUba@nU|UhHdF_A`C}GiCyN^kDdBcGyDImCbDOA');
      url += `&path=enc:${r.description}&key=AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE`;

      return url;
    },

    filter: _.debounce(function () {

      this.search = this.search.toUpperCase();

      if(!this.allRoutes)
        return;

      if (this.search == '') {
        this.routes = this.allRoutes;
        this.page = this.page.itemCount(this.routes.length);

        if(this.routes.length === 0) {
          this.msgStrong = 'Rota não encontrada!';
          this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
          this.warning = true;
          this.showAlert = true;
        }
        return;
      }
      this.routes = this.allRoutes.filter(value => {
        let a = value.name.toUpperCase().indexOf(this.search) >= 0 || value.flexField1 && value.flexField1.toUpperCase().indexOf(this.search) >= 0 || value.flexField2 && value.flexField2.toUpperCase().indexOf(this.search) >= 0;
        let b =_.filter(value.points, (o) => {
          
          
          return o.address && o.address.toUpperCase().indexOf(this.search) >= 0;
        }).length > 0;
        
        return a || b;
      });

      if(this.routes.length == 0) {
        this.msgStrong = 'Rota não encontrada!';
        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
        this.warning = true;
        this.showAlert = true;
      }else {
        this.showAlert = false;
      }

      this.page = this.page.itemCount(this.routes.length);

    }, 400),


  },
  components: {
    Pagination
  }
}



// WEBPACK FOOTER //
// ./src/components/route-resume.js